import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "CN_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#CN_svg__a)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 0h32v24H0V0z", fill: "#E31D1C" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.015 4.548l-1.01.61.23-1.19-.84-.89 1.139-.049.481-1.111.482 1.111h1.137l-.839.939.253 1.19-1.032-.61zM7.017 9.607l-2.88 1.551.657-3.027-2.4-2.265 3.249-.122 1.374-2.826 1.375 2.826h3.242L9.241 8.131l.72 3.027-2.944-1.551zM17.015 8.548l-1.01.61.23-1.19-.84-.89 1.139-.049.482-1.111.481 1.111h1.137l-.839.939.253 1.19-1.032-.61zM16.015 12.548l-1.01.61.23-1.19-.84-.89 1.139-.049.481-1.111.482 1.111h1.137l-.839.939.253 1.19-1.032-.61zM13.015 15.548l-1.01.61.23-1.19-.84-.89 1.139-.049.481-1.111.482 1.111h1.137l-.839.939.253 1.19-1.033-.61z",
      fill: "#FECA00"
    }
  ))
);
export {
  t as default
};
